import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { PaymentTypeModel } from './paymentType.model'
import { environment } from '../../../../environments/environment'
import { catchError, map, Observable } from 'rxjs'

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root',
})
export class PaymentTypeService {
  constructor(private http: HttpClient) {}

  addPaymentType(paymenttype: PaymentTypeModel) {
    
    return this.http
      .post(API_URL + '/PaymentType/CreatePaymentType', paymenttype, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  updatePaymentType(paymenttype: PaymentTypeModel) {
    
    return this.http
      .put(API_URL + '/PaymentType/UpdatePaymentType', paymenttype, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getAllPaymentTypes(): Observable<PaymentTypeModel[]> {
    return this.http.get(API_URL + '/PaymentType/ReadPaymentTypes', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  deletePaymentType(paymenttype: PaymentTypeModel) {
    
    return this.http
      .delete(API_URL + '/PaymentType/DeletePaymentType', {
        headers: {},
        body: paymenttype,
        withCredentials: true
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
